import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-parts',
  templateUrl: './parts.component.html',
})

export class PartsComponent implements OnInit {
  countries: Array<Document> = [
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'parts-list-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
